import { builderFetch } from '../../../utilities';

// Translatable strings
const strings = UncannyAutomator._core.i18n.walkthrough._global.set_walkthrough_progress;

/**
 * Sends a POST request to update the progress of a specific walkthrough.
 * It can be used to close the walkthrough or update its progress percentage.
 * Upon successful update, a custom event is dispatched to the document.
 *
 * @param {String} id - The unique identifier for the walkthrough.
 * @param {Object} options - Options for updating the walkthrough.
 * @param {Boolean} [options.closeRequested=false] - Determines if the walkthrough should be closed.
 * @param {String} [options.stepID=''] - The current step ID of the walkthrough; defaults to an empty string if not provided.
 * @param {Number} [options.progressPercentage=0] - The current progress percentage of the walkthrough; defaults to 0 if not provided.
 * @return {Promise<Object>} A promise that resolves with the API response object or undefined if the request fails.
 */
const setWalkthroughProgress = async ( id, { closeRequested = false, stepID = '', progressPercentage = 0 } ) => {
	return builderFetch( {
		endpoint: 'set_walkthrough_progress',
		method: 'POST',
		data: {
			id: id,
			close_requested: closeRequested,
			step_id: stepID,
			progress_percentage: progressPercentage
		},
		snackbar: {
			// Show the loading and success snackbar only when the walkthrough is being closed
			// eslint-disable-next-line no-undefined
			loading: closeRequested ? strings.closing_walkthrough : undefined,
			// eslint-disable-next-line no-undefined
			success: closeRequested ? strings.closing_walkthrough : undefined,
		}
	} ).then( response => {
		// Check if the call was successful
		if ( response.success ) {
			// Send custom event to the document
			document.dispatchEvent( new CustomEvent( 'uap/builder/core/walkthrough/update-walkthrough', {
				detail: {
					id: id,
					close_requested: closeRequested,
					step_id: stepID,
					progress_percentage: progressPercentage
				}
			} ) );
		}

		return response;
	} );
}

export default setWalkthroughProgress;
